import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { useClientConfig } from "hooks/useClientConfig";
import { profileView } from "../configs/@types";
import { VisibleActivityEnum } from "utils/@types";

const fetchActivityItemsFromWorker = async (
  workerID: string,
  viewActivities: profileView,
  initialDate?: Date,
) => {
  const params: {
    day: number;
    month: number;
    year: number;
    hasWorkitem: boolean;
  } = {
    hasWorkitem: true,
    day: initialDate?.getDate() ?? new Date().getDate(),
    month: initialDate?.getMonth() ?? new Date().getMonth(),
    year: initialDate?.getFullYear() ?? new Date().getFullYear(),
  };

  const { data } = await apiInputService.get(
    `/frontend/activityItem/${workerID}`,
    {
      params:
        viewActivities === VisibleActivityEnum.MONTHLY
          ? params
          : {
              hasWorkitem: true,
            },
    },
  );

  return data;
};

export const useActivityItemsFromWorkerWithStack = (
  workerID: string,
  initialDate?: Date,
  options?: any,
) => {
  const { t } = useTranslation("list-messages");
  const { viewActivities } = useClientConfig();
  const refetchCount = useRef(0);

  return useQuery<any[]>(
    [
      "activity-items-worker",
      workerID,
      initialDate?.toLocaleDateString(),
      viewActivities,
    ],
    async () => {
      const result = await fetchActivityItemsFromWorker(
        workerID,
        viewActivities,
        initialDate,
      );
      refetchCount.current++;

      if (
        !toast.isActive("danger-query-will-not-refetch") &&
        Math.pow(2, refetchCount.current) * 10000 > 1200000
      )
        toast.warning(t("danger-query-will-not-refetch"), {
          autoClose: false,
          toastId: "danger-query-will-not-refetch",
        });

      return result;
    },
    {
      refetchInterval: Math.pow(2, refetchCount.current) * 10000,
      enabled: Math.pow(2, refetchCount.current) * 10000 <= 1200000,
      refetchOnWindowFocus: true,
      ...options,
    },
  );
};
